import React, { useContext, useEffect, useState } from 'react';
import { useGlobalState } from '../stateProvider/StateProvider';
import Form from '../forms/Form';
import Input from '../forms/Input';
import { QuestRoute } from '../api/QuestRoutes';
import Select from '../forms/Select';
import { between, createNewUser, generateId, getDaysInMonth, getMonths } from '../utility/functions';
import HamQuest from '../api/HamQuestGiver';
import Button from '../forms/Button';
import { useNavigate } from 'react-router-dom';
import EmailInput from '../forms/formComponents/EmailInput';
import WCSignUp from './WCSignUp';
import PhoneNumberInput from '../forms/formComponents/PhoneNumberInput';
import Row from '../layout/Row';
import { UserContexts } from '../stateProvider/UsersContext';
import LoadingEllipsis from '../forms/LoadingEllipsis';
import ModalFactory from '../Modal';
import { isDev } from '../../constants/config';


const AddNewCustomer = ({ modalId, isChild, ...props }) => {
    const {
        state: {
            states,
            locations
        },
    } = useGlobalState();

    const context = useContext(UserContexts);

    const navigate = useNavigate();

    const OpenUser = (id) => {
        ModalFactory.close(modalId)
        navigate('/user/' + id, { replace: true });
    }

    const months = getMonths();

    const commonUserData = {
        email: '',
        confirmEmail: '',
        firstName: '',
        lastName: '',
        cellPhoneNumber: '',
        zipPostalCode: '',
        birthdayDayMonth: '',
        birthdayDay: '',
        locationId: '',
        license: '',
        state: '',
        year: '',
        make: '',
        model: '',
        color: '',
    }

    const [userInputs, setUserInputs] = useState(isDev ? { ...commonUserData, ...createNewUser() } : { ...commonUserData });

    useEffect(() => {
        if(props.license)
        setUserInputs((prev) => ({...prev, license: props.license}));
    }, []);

    return (
        <Form
            inputs={{ ...userInputs }}
            onSubmit={e => (
                HamQuest.post(QuestRoute.user.add, {
                    user: { ...e },
                    vehicle: { ...e }
                })
                    .then(async res => {
                        const id = generateId();

                        if (!isChild) {
                            await ModalFactory.promise({
                                id,
                                callback: () => context.manualRefresh(res.customerId),
                                title: (<>Fetching New User<LoadingEllipsis /></>),
                            })
                        }
                        ModalFactory.close(id)

                        ModalFactory.update({
                            id: modalId,
                            title: `${res.firstName}'s Account Created`,
                            buttons: [
                                <Button
                                    label={`To User's Account`}
                                    onClick={() => OpenUser(res.customerId)}
                                />,
                                <WCSignUp child={isChild ? res : null} />
                            ],
                            type: 'success',
                            closeAfter: true
                        })

                        if (typeof props.callback === 'function')
                            props.callback();

                    })
                    .catch(ModalFactory.catch)
            )}
        >
            {({ values }) => (
                <>
                    <Row wrap>
                        <EmailInput
                            autoComplete='off'
                        />
                        <Input
                            label='Confirm Email'
                            name='confirmEmail'
                            type='email'
                            confirmation='email'
                            autoComplete='off'
                            required
                        />
                    </Row>

                    <Row wrap>
                        <Input
                            label='First Name'
                            name='firstName'
                            autoComplete='off'
                            required
                        />
                        <Input
                            label='Last Name'
                            name='lastName'
                            autoComplete='off'
                            required
                        />
                    </Row>

                    <Row wrap>
                        <PhoneNumberInput
                            name='cellPhoneNumber'
                        />
                        <Input
                            label='Postal Code'
                            name='zipPostalCode'
                            autoComplete='off'
                            required
                        />
                    </Row>


                    <Row wrap>
                        <Select
                            label='Birth Month'
                            name='birthdayMonth'
                            options={months}
                            callback={e => {
                                values.birthdayDay = between(values.birthdayDay || 1, 1, getDaysInMonth(e) + 1)
                            }}
                            nullable
                        />
                        <Input
                            label='Birth Day'
                            name='birthdayDay'
                            type='number'
                            sanitize={e => {
                                if (!e) return e;
                                return between(parseInt(e), 1, getDaysInMonth(values.birthdayDayMonth) + 1)
                            }}
                        />
                    </Row>

                    <Select
                        label='Assign to a Location'
                        name='locationId'
                        options={locations}
                        nullable
                    />

                    <Row wrap>
                        <Input
                            label='License Plate'
                            name='license'
                            sanitize={e => {
                                e = e.replace(/./g, (char) => char.toUpperCase());
                                e = e.replace(/[^a-z0-9]/gi, '');
                                return e;
                            }}
                            maxLength={8}
                            autoComplete='off'
                            required
                            {...(props.license ? {readOnly: true} : {})}
                        />
                        <Select
                            label='State'
                            name='state'
                            options={states}
                            required
                        />
                    </Row>

                    <Row wrap>
                        <Input
                            label='Vehicle Make'
                            name='make'
                            required
                        />
                        <Input
                            label='Vehicle Model'
                            name='model'
                            required
                        />
                    </Row>

                    <Row wrap>
                        <Input
                            label='Vehicle Year'
                            name='year'
                            min={1950}
                            type='number'
                            autoComplete='off'
                            required
                        />

                        <Input
                            label='Vehicle Color'
                            name='color'
                            required
                        />
                    </Row>



                </>
            )}
        </Form >
    )
}

export default AddNewCustomer;
